import React from 'react';
import { Plane, UtensilsCrossed, Car, Building2, Wrench, Fuel, Shield, Users } from 'lucide-react';

export function ServiceIllustration() {
  const services = [
    { Icon: Plane, label: 'Charter', color: 'from-blue-400 to-blue-600' },
    { Icon: UtensilsCrossed, label: 'Catering', color: 'from-orange-400 to-red-500' },
    { Icon: Car, label: 'Transport', color: 'from-green-400 to-emerald-600' },
    { Icon: Building2, label: 'FBO', color: 'from-purple-400 to-indigo-600' },
    { Icon: Wrench, label: 'Maintenance', color: 'from-yellow-400 to-orange-500' },
    { Icon: Fuel, label: 'Fuel', color: 'from-red-400 to-pink-600' },
    { Icon: Shield, label: 'Security', color: 'from-gray-400 to-slate-600' },
    { Icon: Users, label: 'Crew', color: 'from-teal-400 to-cyan-600' },
  ];

  return (
    <div className="relative">
      {/* Central hub - smaller on mobile */}
      <div className="flex justify-center mb-6 sm:mb-8">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-400 to-blue-500 rounded-full blur-xl sm:blur-2xl opacity-60 animate-pulse"></div>
          <div className="relative p-3 sm:p-6 bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-xl rounded-full border border-white/30 shadow-2xl">
            <Plane className="h-6 w-6 sm:h-12 sm:w-12 text-white" />
          </div>
        </div>
      </div>

      {/* Service grid - more compact on mobile */}
      <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-4 lg:gap-6 max-w-5xl mx-auto">
        {services.map(({ Icon, label, color }, index) => (
          <div
            key={label}
            className="group relative"
            style={{
              animationDelay: `${index * 100}ms`,
            }}
          >
            <div className="relative p-2 sm:p-4 lg:p-6 bg-white/10 backdrop-blur-xl rounded-lg sm:rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-2xl group">
              <div className="flex flex-col items-center gap-1 sm:gap-3">
                <div className={`p-1.5 sm:p-3 lg:p-4 bg-gradient-to-r ${color} rounded-lg sm:rounded-xl shadow-lg group-hover:shadow-xl transition-shadow duration-300`}>
                  <Icon className="h-3 w-3 sm:h-5 sm:w-5 lg:h-6 lg:w-6 text-white" />
                </div>
                <span className="text-[10px] sm:text-xs lg:text-sm font-medium text-white/90 text-center leading-tight">
                  {label}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Stats - smaller and more compact on mobile */}
      <div className="grid grid-cols-3 gap-4 sm:gap-8 max-w-lg sm:max-w-2xl mx-auto mt-8 sm:mt-16 pt-6 sm:pt-8 border-t border-white/20">
        <div className="text-center">
          <div className="text-lg sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">500+</div>
          <div className="text-[10px] sm:text-sm text-white/70">Airports</div>
        </div>
        <div className="text-center">
          <div className="text-lg sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">10K+</div>
          <div className="text-[10px] sm:text-sm text-white/70">Providers</div>
        </div>
        <div className="text-center">
          <div className="text-lg sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">99.9%</div>
          <div className="text-[10px] sm:text-sm text-white/70">Uptime</div>
        </div>
      </div>
    </div>
  );
}